import React from "react";
import {
  AiProgressReportFrame,
  ComparisonSection,
} from "./AiProgressSummaryView";
import { AiBloodProgressSummary } from "./aiBloodProgressSummaryResponse";

const AiBloodProgressSummaryView = ({
  summary,
  variant = "screen",
}: {
  summary: AiBloodProgressSummary;
  variant?: "screen" | "pdf";
}) => (
  <AiProgressReportFrame summary={summary} variant={variant}>
    {summary.systems.map((system, index) => (
      <ComparisonSection
        key={index}
        title={system.name || `System ${index + 1}`}
        summaryTitle={system.name ? `${system.name} summary` : "System summary"}
        section={system}
      />
    ))}
  </AiProgressReportFrame>
);

export default AiBloodProgressSummaryView;
